// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"index_carousel-container__rp8RG","scroll-target":"index_scroll-target__ysZjt"};